import React, { useState, useEffect } from 'react';
import { Paper, CircularProgress } from '@mui/material';
import {
  collection, doc, getDoc, setDoc,
} from 'firebase/firestore';
import { useTranslation } from 'react-i18next';
import useGlobal from 'global-state/store';
import { useFirestore } from 'firebaseHooks/FirestoreContext';
import ExpirationCertificatesReportForm from './ExpirationCertificatesReportForm';

function CertificatesMonitoring() {
  const { t } = useTranslation();
  const db = useFirestore();
  const [loadingStatus, setLoadingStatus] = useState('initial');
  const [initialValues, setInitialValues] = useState(null);
  const [globalState, globalActions] = useGlobal();

  useEffect(() => {
    const fetchData = async () => {
      const dataRef = doc(
        db,
        'organizations',
        globalState.activeOrganization,
        'apps',
        'digitank-gauged-containers',
        'data',
        'monitoring',
      );
      const dataSnap = await getDoc(dataRef);

      if (dataSnap.exists()) {
        setInitialValues(
          {
            reportCertificateExpiration: dataSnap.data().reportCertificateExpiration || { active: false, emails: [] },
          },
        );
      } else {
        setInitialValues({ reportCertificateExpiration: { active: false, emails: [] } });
      }
      setLoadingStatus('done');
    };

    if (loadingStatus === 'initial' && !['initial', 'loading'].includes(globalState.userStatus)) {
      setLoadingStatus('loading');
      fetchData();
    }
  }, [db, globalState.activeOrganization, globalState.userStatus, loadingStatus]);

  const handleSubmit = async (values) => {
    const dataCollectionRef = collection(
      db,
      'organizations',
      globalState.activeOrganization,
      'apps',
      'digitank-gauged-containers',
      'data',
    );
    const monitoringDocRef = doc(dataCollectionRef, 'monitoring');
    await setDoc(monitoringDocRef, values, { merge: true });
    globalActions.setSnackbarMessage({ message: t('success'), severity: 'success' });
  };

  return (
    <Paper sx={{ p: 3 }}>
      {loadingStatus !== 'done' ? (
        <CircularProgress />
      ) : (
        <ExpirationCertificatesReportForm
          initialValues={initialValues}
          onSubmit={handleSubmit}
        />
      )}
    </Paper>
  );
}

export default CertificatesMonitoring;
